import { createFileRoute } from "@tanstack/react-router";
import { ExternalLink } from "lucide-react";
import { Button, Card, CardContent, CardHeader, CardTitle, Section } from "@alight/ui";
import { useSeo } from "../lib/seo";
import { useBlock } from "../lib/content";
import { PageIntro } from "../components/PageIntro";

export const Route = createFileRoute("/uni-christian-groups")({
  component: UniGroupsPage,
});

function UniGroupsPage() {
  const c = useBlock("uniGroups");
  const banners = useBlock("banners");

  useSeo({
    title: "Uni Christian groups | Connect Sydney",
    description:
      "For Sydney Year 12 leavers: find the Christian group at your university before you get there — Heading to Uni, AFES, the National Training Event and Meet Jesus.",
    path: "/uni-christian-groups",
    image: banners.uniGroupsImage,
  });
  return (
    <>
      <PageIntro
        eyebrow="Before semester one"
        title="University Christian groups"
        description={c.intro}
        image={banners.uniGroupsImage}
        imageAlt={banners.uniGroupsImageAlt}
      />

      <Section tone="paper" spacing="lg">
        <div className="grid gap-6 md:grid-cols-2">
          {c.sections.map((s, i) => (
            <Card key={i} className="flex h-full flex-col p-6">
              <CardHeader className="p-0">
                <CardTitle className="font-heading text-2xl">{s.title}</CardTitle>
              </CardHeader>
              <CardContent className="flex flex-1 flex-col p-0">
                <p className="mt-4 flex-1 leading-relaxed text-muted">{s.body}</p>
                <div className="mt-5 flex flex-wrap gap-3">
                  {s.link1Href && (
                    <Button asChild size="sm">
                      <a href={s.link1Href} target="_blank" rel="noreferrer">
                        {s.link1Label || s.link1Href}
                        <ExternalLink className="ml-1.5 h-3.5 w-3.5" aria-hidden />
                      </a>
                    </Button>
                  )}
                  {s.link2Href && (
                    <Button asChild size="sm" variant="outline">
                      <a href={s.link2Href} target="_blank" rel="noreferrer">
                        {s.link2Label || s.link2Href}
                        <ExternalLink className="ml-1.5 h-3.5 w-3.5" aria-hidden />
                      </a>
                    </Button>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </Section>
    </>
  );
}
